import { useContext } from "react";
import { ConversationContext } from "common/providers/ConversationProvider";

export const useConversation = () => useContext(ConversationContext);

export default useConversation;
